/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ClientResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ClientResource model module.
   * @module model/ClientResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ClientResource</code>.
   * The resource includes the information of client.
   * @alias module:model/ClientResource
   * @class
   * @param name {String} The name of the client.
   */
  var exports = function(name) {
    var _this = this;







    _this['name'] = name;

  };

  /**
   * Constructs a <code>ClientResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ClientResource} obj Optional instance to populate.
   * @return {module:model/ClientResource} The populated <code>ClientResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('isActive')) {
        obj['isActive'] = ApiClient.convertToType(data['isActive'], 'Boolean');
      }
      if (data.hasOwnProperty('allowedOrigins')) {
        obj['allowedOrigins'] = ApiClient.convertToType(data['allowedOrigins'], ['String']);
      }
      if (data.hasOwnProperty('allowedIpAddresses')) {
        obj['allowedIpAddresses'] = ApiClient.convertToType(data['allowedIpAddresses'], ['String']);
      }
      if (data.hasOwnProperty('clientType')) {
        obj['clientType'] = ApiClient.convertToType(data['clientType'], 'String');
      }
      if (data.hasOwnProperty('grantedRoles')) {
        obj['grantedRoles'] = ApiClient.convertToType(data['grantedRoles'], ['String']);
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('sharedMode')) {
        obj['sharedMode'] = ApiClient.convertToType(data['sharedMode'], 'String');
      }
    }
    return obj;
  }

  /**
   * The Id of a client.
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * A value indicates whether the client is active or not. If it can work only the value is true, otherwise it won't work.
   * @member {Boolean} isActive
   */
  exports.prototype['isActive'] = undefined;
  /**
   * The whitelist of the origins. It works only for JavaScript clients.
   * @member {Array.<String>} allowedOrigins
   */
  exports.prototype['allowedOrigins'] = undefined;
  /**
   * The whitelist of the IP addresses. It works only for JavaScript clients.
   * @member {Array.<String>} allowedIpAddresses
   */
  exports.prototype['allowedIpAddresses'] = undefined;
  /**
   * The type of the client. The supported types are \"JavaScript\" and \"NativeConfidential\". Defaults to \"JavaScript\".
   * @member {module:model/ClientResource.ClientTypeEnum} clientType
   */
  exports.prototype['clientType'] = undefined;
  /**
   * The roles granted to the client.
   * @member {Array.<String>} grantedRoles
   */
  exports.prototype['grantedRoles'] = undefined;
  /**
   * The name of the client.
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * Indicates either \"Origin\" or \"IP Address\" is used to as the whitelist for requests. Acceptable values are \"Origin\" and \"IpAddress\". Defaults to \"Origin\" for \"JavaScript\" and \"IpAddress\" for \"NativeConfidential\".
   * @member {module:model/ClientResource.SharedModeEnum} sharedMode
   */
  exports.prototype['sharedMode'] = undefined;


  /**
   * Allowed values for the <code>clientType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ClientTypeEnum = {
    /**
     * value: "JavaScript"
     * @const
     */
    "JavaScript": "JavaScript",
    /**
     * value: "NativeConfidential"
     * @const
     */
    "NativeConfidential": "NativeConfidential"  };

  /**
   * Allowed values for the <code>sharedMode</code> property.
   * @enum {String}
   * @readonly
   */
  exports.SharedModeEnum = {
    /**
     * value: "Origin"
     * @const
     */
    "Origin": "Origin",
    /**
     * value: "IpAddress"
     * @const
     */
    "IpAddress": "IpAddress"  };


  return exports;
}));



